import { HISTORY_SCOPE, HISTORY_LABEL } from '@src/constants/history';

const dubbingHistoryConfig = {
  scope: HISTORY_SCOPE.DUBBING,
  deferLabels: [
    HISTORY_LABEL.EDIT_BLOCK_TEXT,
    HISTORY_LABEL.CHANGE_BLOCK_TIMING,
    // A volume slider fires on every pointer move, so the drag coalesces into
    // one entry, closed on release (onChangeCommitted). A mute click closes it
    // itself.
    HISTORY_LABEL.CHANGE_TRACK_VOLUME,
  ],
};

export default dubbingHistoryConfig;
